exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".in-form-columns-settings-editor{padding:1rem}.enum-option-row{cursor:pointer}.enum-option-row,.tr-enum{text-align:center;line-height:40px}.td-enum,.th-enum{border:1px solid}.enum-settings-wrapper>label{margin:0}.enum-settings-wrapper hr{margin:.5rem 0}.enum-settings-wrapper table{width:100%}.enum-settings-wrapper table td,.enum-settings-wrapper table th{border-color:#ccc}.in-form-form-wrapper{position:relative;min-height:10rem;background:#fff;padding-bottom:1rem}div.disabled-div{pointer-events:none;opacity:.4;cursor:not-allowed}", ""]);

// exports
